<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext withWidget">
      <tracking-progress :transDataSet="transDate"></tracking-progress>
      <form @submit.prevent="submitForm">
      <div class="join container">
        <div class="joinTitle">
          <h3>아이디/비밀번호</h3>
          <p class="warn">필수입력정보입니다.</p>
        </div>
          <div class="joinContext first userInput">
            <div class="warnSpace">
              <p class="warn" :class="{possible : idCheckButton, errorLaise: form.id.active}" v-text="form.id.message"></p>
            </div>
            <div class="article require">
              <div class="inputHeader">
                <p>아이디</p>
              </div>
              <input  type="text" v-model="form.id.value" maxlength="21" @keyup="blurId()" placeholder="아이디를 입력해주세요." class="idInput idCheck"/>
              <button type="button" :class="{possible : idCheckButton }" class="authorized pointer" @click="checkJoinId">중복확인</button>
              <span class="imgWrap idPossible" v-if="idCheckButton">
                <img src="@/assets/images/ck_on.svg">
              </span>
            </div>
            <div class="warnSpace">
              <p class="warn"  v-text="form.password.errorTxt" v-if="form.password.hasError"></p>
            </div>
            <div class="article require" :class="{errorLaise : form.password.hasError}">
              <div class="inputHeader">
                <p>비밀번호</p>
              </div>
              <input type="password"  v-model="form.password.value" maxlength="20" @keyup="blurPassword()"  placeholder="비밀번호를 입력해주세요." class="pwInput"/>
            </div>
            <div class="warnSpace">
              <p class="warn"  v-text="form.passwordConfirm.errorTxt" v-if="form.passwordConfirm.hasError"></p>
            </div>
            <div class="article require" :class="{errorLaise : form.passwordConfirm.hasError}">
              <div class="inputHeader">
                <p>비밀번호확인</p>
              </div>
             <input type="password" v-model="form.passwordConfirm.value" maxlength="20" @keyup="blurPasswordConfirm()" placeholder="비밀번호 확인을 입력해주세요." class="pwConfirmInput"/>
            </div>
           <!-- <div class="article require">
              <p>전화번호</p><input  type="text" v-model="form.tel.value" maxlength="22" @blur="blurTel()" />
            </div>
            <div class="article require">
              <p>기기토큰</p> <input type="text"  v-model="form.deviceToken.value" @blur="blurDeviceToken()" />
            </div>-->

            <!--  <p class="warn"
                 v-if="form.tel.hasError" v-text="form.tel.errorTxt"></p>-->

           <!-- <p class="warn"
               v-if="form.deviceToken.hasError" v-text="form.deviceToken.errorTxt"></p>-->
          </div>
            <div class="joinTitle">
              <h3>이메일/연락처</h3>
            </div>
            <div class="joinContext userInput">
              <div class="warnSpace">
                <p class="warn"  v-text="form.mail.errorTxt" v-if="form.mail.hasError"></p>
              </div>
              <div class="article require half" :class="{errorLaise : form.mail.hasError}">
                <div class="inputHeader">
                  <p>이메일</p>
                </div>
                <div class="halfWrap">
                  <input type="text" v-model="mailInput.value" @keyup="blurMailInput()">
                  <span class="narrow">@</span>
                  <input type="text" v-model="mailInput2.value" @keyup="blurMailInput2()"/>
                </div>
              </div>
              <div class="warnSpace">
                <p class="warn"  v-text="form.tel.errorTxt" v-if="form.tel.hasError"></p>
              </div>
              <div class="article require" :class="{errorLaise : form.mail.hasError}">
                <div class="inputHeader">
                  <p>연락처</p>
                </div>
                <input type="text" v-model="form.tel.value" maxlength="13" @keyup="blurTel()"
                       @input="formatPhoneNumber(form.tel.value)" placeholder="전화번호를 입력해주세요."/>
              </div>
          </div>
      </div>
    <div class="btnWrap"  :class="{visible : idCheckButton && form.id.flag && form.password.flag && form.passwordConfirm.flag && form.mail.flag && form.mutateId.flag && form.tel.flag }">
      <button type="submit">회원가입 완료</button>
    </div>
      </form>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>
<script>
import AppHeader from '../../components/AppHeader'
import AppSidebar from '../../components/AppSidebar'
import TrackingProgress from '../../components/TrackingProgress'
import AddPopup from '@/components/AddPopup'
import errorParser from '@/utils/error-parser'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'

export default {
  data () {
    return {
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '성함, 생년월일, 성별 정보가 없습니다.',
        confirmBtnText: '확인',
        count: 'single',
        nextLink: '',
        closeType: 'close'
      },
      transDate: {
        headerName: '회원가입',
        progressNum: '50%',
        chapterNum: 2,
        prevUrl: '/authorizedTemporary'
      },
      underAgeChecked: false,
      overAgeChecked: false,
      buttonUp: false,
      alertFailMessage: '사용할 수 없는 아이디 입니다.',
      pwChecked: false,
      idCheckButton: false,
      alertSuccessMessage: '사용 가능한 아이디',
      carryError: '성함, 생년월일, 성별 정보가 없습니다.',
      mailInput: {
        value: '',
        flag: false
      },
      mailInput2: {
        value: '',
        flag: false
      },
      form: {
        id: {
          value: '',
          flag: false,
          active: false,
          message: '',
          hasError: false,
          errorTxt: '필수 항목입니다.',
          hasPossible: false,
          possibleTxt: ''
        },
        mutateId: {
          value: '',
          flag: false
        },
        idConfirm: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        password: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        passwordConfirm: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        mail: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        gender: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        tel: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        birthDate: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        userName: {
          value: '',
          flag: false,
          hasError: false,
          errorTxt: '필수 항목입니다.'
        },
        setCount: false
      }
    }
  },
  created () {
    console.log('est')
    if (history.pushState !== undefined) {
      history.pushState({}, '', location.href)
      window.onpopstate = () => {
        this.callPrev()
      }
    }
    this.carryData()
    if (this.form.birthDate.value === '' || this.form.userName.value === '' || this.form.gender.value === '') {
      this.popupSet.content = this.carryError
      this.popupSet.count = 'another'
      this.popupSet.nextLink = '/authorizedTemporary'
      this.popupSet.closeType = 'action'
      this.popupSet.closeLink = '/authorizedTemporary'
      this.SET_POPUP(true)
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    TrackingProgress,
    AddPopup
  },
  computed: {
    ...mapState([
      'checkPopup'
    ]),
    ...mapGetters([
      'GET_TEMPORARY_DATA'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapMutations('referrer', [
      'SET_REFERRER'
    ]),
    callPrev () {
      if (this.setCount) {
        this.$router.push('/ChoiceType')
      } else {
        history.go(1)
      }
      this.setCount = true
      // 클로즈 함수 구현
    },
    formatPhone (obj) {
      const number = obj.toString().replace(/[^0-9]/g, '')
      let phone = ''
      if (number.length < 4) {
        return number
      }
      if (number.length < 7) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3)
      } else if (number.length < 11) {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 3)
        phone += '-'
        phone += number.substr(6)
      } else {
        phone += number.substr(0, 3)
        phone += '-'
        phone += number.substr(3, 4)
        phone += '-'
        phone += number.substr(7)
      }
      return phone
    },
    formatPhoneNumber (obj) {
      this.form.tel.value = this.formatPhone(obj)
    },
    blurTel () {
      this.form.tel.flag = false
      this.checkTel()
    },
    checkTel () {
      if (this.form.tel.flag) return true
      const tel = this.form.tel.value.replace(/\s/gi, '')
      if (tel === '') {
        this.form.tel.hasError = true
        this.form.tel.errorTxt = '전화번호를 입력해주세요.'
        return false
      }
      const isNumber = /^01(0|1|[6-9]?)-?([0-9]{3,4})-?([0-9]{4})$/
      if (!isNumber.test(tel)) {
        this.form.tel.hasError = true
        this.form.tel.errorTxt = '전화번호를 정확히 입력해주세요.'
        return false
      }
      this.form.tel.flag = true
      this.form.tel.hasError = false
      this.form.tel.errorTxt = ''
      return true
    },
    blurId () {
      this.form.id.flag = false
      this.idCheckButton = false
      this.form.mutateId.flag = false
      this.checkId()
    },
    checkId () {
      if (this.form.id.flag) return true
      const id = this.form.id.value.replace(/\s/gi, '')
      if (id === '') {
        this.form.id.active = true
        this.form.id.message = '아이디를 입력해주세요.'
        return false
      }
      const isHan = /^[a-z|A-Z|0-9|]{3,21}$/
      if (!isHan.test(id)) {
        this.form.id.active = true
        this.form.id.message = '영문 및 숫자만 입력이 가능합니다.'
        this.form.id.flag = false
        return false
      }
      this.form.id.flag = true
      this.form.id.active = false
      this.form.id.message = ''
      return true
    },
    blurPassword () {
      this.form.password.flag = false
      this.checkPassword()
    },
    checkPassword () {
      if (this.form.password.flag) return true
      const password = this.form.password.value.replace(/\s/gi, '')
      if (password === '') {
        this.form.password.hasError = true
        this.form.password.errorTxt = '비밀번호를 입력해주세요.'
        return false
      }
      const isPw = /^(?=.*[a-zA-Z])(?=.*[0-9]).{8,20}$/
      if (!isPw.test(password)) {
        this.form.password.hasError = true
        this.form.password.flag = false
        this.form.password.errorTxt = '비밀번호는 영문대/소문자+숫자 조합으로 8~20자를 설정해주세요.'
        return false
      }
      /*  */
      this.form.password.flag = true
      this.form.password.hasError = false
      this.form.password.errorTxt = ''
      if (this.pwChecked) {
        this.blurPasswordConfirm()
      }
      return true
    },
    blurPasswordConfirm () {
      this.form.passwordConfirm.flag = false
      this.checkPasswordConfirm()
      console.log('비밀번호체크')
    },
    checkPasswordConfirm () {
      if (this.form.passwordConfirm.flag) return true
      const password = this.form.passwordConfirm.value.replace(/\s/gi, '')
      if (password === '') {
        this.form.passwordConfirm.hasError = true
        this.form.passwordConfirm.errorTxt = '비밀번호 확인을 입력해주세요.'
        return false
      }
      if (password !== this.form.password.value) {
        this.form.passwordConfirm.flag = false
        this.form.passwordConfirm.hasError = true
        this.form.passwordConfirm.errorTxt = '비밀번호가 일치하지 않습니다.'
        return false
      }
      this.form.passwordConfirm.flag = true
      this.form.passwordConfirm.hasError = false
      this.form.passwordConfirm.errorTxt = ''
      this.pwChecked = true
      return true
    },
    blurMailInput () {
      this.form.mail.flag = false
      this.checkMailInput()
    },
    checkMailInput () {
      if (this.form.mail.flag) return true
      const input = this.mailInput.value.replace(/\s/gi, '')
      if (input === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      this.mailInput.flag = true
      this.blurMail()
      return true
    },
    blurMailInput2 () {
      this.form.mail.flag = false
      this.checkMailInput2()
    },
    checkMailInput2 () {
      if (this.form.mail.flag) return true
      const input = this.mailInput2.value.replace(/\s/gi, '')
      if (input === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      this.mailInput2.flag = true
      this.blurMail()
      return true
    },
    blurMail () {
      this.form.mail.flag = false
      this.checkMail()
    },
    checkMail () {
      if (this.form.mail.flag && this.mailInput.flag && this.mailInput2.flag) return true
      const mail = this.mailInput.value + '@' + this.mailInput2.value
      this.form.mail.value = mail
      if (mail === '') {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일을 입력해주세요.'
        return false
      }
      // eslint-disable-next-line no-useless-escape
     const isMail = /^[0-9a-zA-Z ]([-_\.]?[0-9a-zA-Z ])*@[0-9a-zA-Z ]([-_\.]?[0-9a-zA-Z ])*\.[a-zA-Z ]{2,3}$/i
      if (!isMail.test(mail)) {
        this.form.mail.hasError = true
        this.form.mail.errorTxt = '이메일 형식에 맞지 않습니다.'
        return false
      }
      this.form.mail.flag = true
      this.form.mail.hasError = false
      this.form.mail.errorTxt = ''
      return true
    },
    blurDeviceToken () {
      this.form.deviceToken.flag = false
      this.checkdeviceToken()
    },
    checkdeviceToken () {
      if (this.form.deviceToken.flag) return true
      const deviceToken = this.form.deviceToken.value
      if (deviceToken === '') {
        this.form.deviceToken.hasError = true
        this.form.deviceToken.errorTxt = '기기토큰을 입력해주세요.'
        return false
      }
      this.form.deviceToken.flag = true
      this.form.deviceToken.hasError = false
      this.form.deviceToken.errorTxt = ''
      return true
    },
    async checkJoinId () {
      const id = this.form.id.value
      if (id === '') {
        this.SET_POPUP(true)
        this.popupSet.content = '아이디를 입력해주세요.'
        return false
      }

      const isHan = /^[a-z|A-Z|0-9|]{3,21}$/
      if (!isHan.test(id)) {
        this.form.id.active = true
        this.form.id.message = '영문 및 숫자만 입력이 가능합니다.'
        this.form.id.flag = false
        return false
      }
      try {
        const userData = {
          id: this.form.id.value.replace(/\s/gi, '')
        }
        await this.ID_CHECK(userData)
        this.form.id.flag = true
        this.form.id.active = true
        this.form.id.message = '사용 가능한 아이디입니다.'
        this.idCheckButton = true
        this.form.mutateId.value = userData.id
        this.form.mutateId.flag = true
      } catch (error) {
        console.log('error :', error);
        console.log('임시회원 ID체크 에러에 진입함!')
        if (error.status !== 401) {
          this.form.id.active = true
          this.form.id.message = '사용중인 아이디 입니다.'
          this.form.id.flag = false
          this.idCheckButton = false
          this.form.id.value = ''
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    async transData () {
      try {
        const userData = {
          id: this.form.mutateId.value.replace(/\s/gi, ''),
          password: this.form.password.value.replace(/\s/gi, ''),
          userName: this.form.userName.value.replace(/\s/gi, ''),
          tel: this.form.tel.value.replace(/\s/gi, ''),
          gender: this.form.gender.value,
          birthDate: this.form.birthDate.value.replace(/\s/gi, ''),
          isTemporaryMember: true,
          mail: this.form.mail.value.replace(/\s/gi, ''),
          dupInfo: null
        }
        await this.TRANS_TEMPORARY_USER_DATA(userData)
          .then(() => {
            if (sessionStorage.getItem('joinName')) {
              sessionStorage.removeItem('joinName')
            }
            sessionStorage.setItem('joinName', this.form.userName.value)
          })
          .then(() => {
            this.SET_REFERRER(window.location.href)
            this.$router.push('/joinDoneTemporary')
          })
      } catch (error) {
        console.log('error :', error);
        console.log('임시회원 데이터 저장')
        if (error.status !== 401) {
          this.SET_POPUP(true)
          if (error.data.response.message === 'Mail already exists.') {
            this.popupSet.content = '중복된 이메일입니다.'
            this.initMail()
          } else {
            this.popupSet.content = errorParser.parse(error)
            this.initForm()
          }
        } else {
          await this.$router.push('/login')
        }
      } finally {
      }
    },
    ...mapActions([
      'ID_CHECK',
      'TRANS_TEMPORARY_USER_DATA'
    ]),
    submitForm () {
      if (this.checkAll()) {
        console.log('입력성공')
        this.transData()
      } else {
        if (!this.form.id.flag) {
          this.popupSet.content = '아이디를 확인해주세요.'
          this.SET_POPUP(true)
          this.form.id.active = true
          this.form.id.message = '아이디를 입력해주세요.'
          // document.querySelector('.idInput').focus()
          return false
        }
        if (!this.idCheckButton) {
          this.popupSet.content = '아이디 중복검사를 해주세요.'
          this.SET_POPUP(true)
          this.form.id.active = true
          this.form.id.message = '중복검사를 해주세요.'
          // document.querySelector('.idInput').focus()
          return false
        }
        if (!this.form.password.flag) {
          this.popupSet.content = '비밀번호를 확인해주세요.'
          this.SET_POPUP(true)
          this.form.password.hasError = true
          this.form.password.errorTxt = '비밀번호를 확인해주세요.'
          // document.querySelector('.pwInput').focus()
          return false
        }
        if (!this.form.password.flag || !this.form.passwordConfirm.flag) {
          this.popupSet.content = '비밀번호와 비밀번호확인을 확인해주세요.'
          this.SET_POPUP(true)
          this.form.passwordConfirm.hasError = true
          this.form.passwordConfirm.errorTxt = '비밀번호와 비밀번호확인을 확인해주세요.'
          // document.querySelector('.pwConfirmInput').focus()
          return false
        }
        if (!this.form.mail.flag) {
          this.popupSet.content = '이메일을 확인해주세요.'
          this.SET_POPUP(true)
          this.form.mail.hasError = true
          this.form.mail.errorTxt = '이메일을 확인해주세요.'
          // document.querySelector('.mailInput').focus()
          return false
        }
        if (!this.form.tel.flag) {
          this.popupSet.content = '전화번호를 확인해주세요.'
          this.SET_POPUP(true)
          this.form.tel.hasError = true
          this.form.tel.errorTxt = '전화번호를 확인해주세요.'
          // document.querySelector('.telInput').focus()
          return false
        }
        console.log('입력실패')
      }
    },
    initFlag () {
      this.form.id.active = false
      this.form.id.flag = false
      this.form.id.message = ''
      this.mailInput.value = ''
      this.mailInput2.value = ''
      this.mailInput.flag = false
      this.mailInput2.flag = false
      this.form.mail.flag = false
      this.form.mutateId.flag = false
      this.form.password.flag = false
      this.form.passwordConfirm.flag = false
      this.idCheckButton = false
      this.pwChecked = false
      this.form.tel.flag = false
    },
    initForm () {
      this.form.id.value = ''
      this.form.mutateId.value = ''
      this.form.password.value = ''
      this.form.passwordConfirm.value = ''
      this.mailInput.value = ''
      this.mailInput2.value = ''
      this.form.mail.value = ''
      this.form.tel.value = ''
      this.initFlag()
    },
    initMail () {
      this.form.mail.value = ''
      this.form.mail.flag = false
      this.mailInput.value = ''
      this.mailInput.flag = false
      this.mailInput2.value = ''
      this.mailInput2.flag = false
    },
    checkAll () {
      return !!(this.form.id.flag && this.form.password.flag &&
        this.form.passwordConfirm.flag && this.form.mail.flag &&
        this.idCheckButton && this.form.mutateId.flag && this.form.tel.flag)
    },
    carryData () {
      this.form.userName.value = this.$store.getters.GET_TEMPORARY_DATA.userName
      this.form.gender.value = this.$store.getters.GET_TEMPORARY_DATA.gender
      this.form.birthDate.value = this.$store.getters.GET_TEMPORARY_DATA.birthDate
      this.form.userName.flag = this.$store.getters.GET_TEMPORARY_DATA.userNameFlag
      this.form.gender.flag = this.$store.getters.GET_TEMPORARY_DATA.genderFlag
      this.form.birthDate.flag = this.$store.getters.GET_TEMPORARY_DATA.birthDateFlag
    }
  },
  beforeDestroy () {
    this.setCount = false
    this.SET_POPUP(false)
  }
}
</script>

<style lang="scss" scoped>
</style>
